<template>
  <Table />
</template>

<script>
import Table from "./component/DataTable";

export default {
  name: "RoleTable",
  components: {
    Table
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  mounted() {
  }
};
</script>
